var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ma-0",staticStyle:{"border-radius":"0","width":"100%","height":"100%","color":"white","border-right":"1px solid #eee"},style:({
    'background-color':
      _vm.$store.state.livechat.app == _vm.social.fullValueForUse
        ? _vm.$vuetify.theme.primary
        : _vm.colors.grey.base
  }),attrs:{"depressed":"","dark":""},on:{"click":function($event){return _vm.$emit('changeApp')}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a7fe44a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/livechat/LivechatTabButton.vue
// module id = null
// module chunks = 